import Utils from '@/common/utils/utils';
import systemField from '@/common/constant/SystemField';
import { cloneDeep } from 'lodash';
import { searchTicketKnowledgeListByFilter } from '@/service/ticketKnowledgeService';
import { getFormMasterListByProject } from '@/service/formManagementService';
import { getTicketById } from '@/service/ticketService';
import { getFormById } from '@/service/formManagementService';
import Constant from '@/common/constant/Constant';

export const getListFieldInForm = (formStructure, fieldList) => {
    let fieldListClone = cloneDeep(fieldList);
    let formData = [];

    if (!Utils.isEmptyObject(formStructure)) {
        for (const fieldNumber in formStructure) {
            if (formStructure.hasOwnProperty(fieldNumber)) {
                let fieldData = {};
                let fieldId = '';

                let formField = formStructure[fieldNumber];

                if (
                    formStructure[fieldNumber].hasOwnProperty('field') &&
                    !Utils.isEmptyArray(fieldListClone)
                ) {
                    fieldId = formStructure[fieldNumber]['field'];
                    fieldData = fieldListClone.find(customField => customField.id === fieldId);
                } else if (
                    formStructure[fieldNumber].hasOwnProperty('sysfield') &&
                    !Utils.isEmptyArray(systemField)
                ) {
                    fieldId = formStructure[fieldNumber]['sysfield'];
                    fieldData = systemField.find(sysField => sysField.id === fieldId);
                }

                if (!Utils.isEmptyObject(fieldData)) {
                    fieldData.required = formField.required;
                    fieldData.publicForCustomer = formField.publicForCustomer;
                    formData.push(fieldData);
                }
            }
        }
    }

    return formData;
};

export const getListItemOfRelatedField = async argsCommon => {

    try {
        let indexFormMasterSelected = Utils.findIndexInArrayById(
            argsCommon.formMasterIdSelected,
            argsCommon.formMasterList
        );

        let indexOfRelatedField = Utils.findIndexInArrayById(
            argsCommon.selectedRelatedField,
            argsCommon.relatedFieldList
        );

        if (indexFormMasterSelected === -1 || indexOfRelatedField === -1) {
            argsCommon.setItemOfSelectedRelatedFieldList([]);
            return;
        }

        argsCommon.setIsLoading(true);
        let itemList = [];
        let itemIdList = [];

        if (!Utils.isEmptyArray(argsCommon.currentUpdateField.structure.listItem)) {
            argsCommon.currentUpdateField.structure.listItem.forEach(item => {
                itemList.push({
                    id: item.itemId,
                    isActive: item.isActive,
                    hitNumber: item.hitNumber,
                    order: item.order,
                    listTicketId: item.listTicketId
                });
                itemIdList.push(item.itemId);
            });
        } else {
            let filterInput = {
                affiliationOrganization:
                    argsCommon.formMasterList[indexFormMasterSelected].affiliationOrganization,
                formIdList: [argsCommon.formMasterList[indexFormMasterSelected].id]
            };

            // call api
            const listTicketOfForm = await searchTicketKnowledgeListByFilter(
                argsCommon.API,
                filterInput
            );

            if (!Utils.isEmptyArray(listTicketOfForm)) {
                listTicketOfForm.forEach(ticket => {
                    const listFieldsValue = Utils.convertJSONDataToObject(
                        Utils.convertJSONDataToObject(ticket.listFieldsValue)
                    );

                    let listItemSelectedInTicket = [];
                    listItemSelectedInTicket = listFieldsValue[`${argsCommon.selectedRelatedField}`];

                    if (!Utils.isEmptyArray(listItemSelectedInTicket)) {
                        listItemSelectedInTicket.forEach(itemId => {
                            if (itemIdList.includes(itemId)) {
                                const indexOfItem = itemList.findIndex(item => item.id === itemId);
                                let itemTmp = itemList[indexOfItem];
                                itemTmp.listTicketId.push(ticket.id);
                                itemList[indexOfItem] = itemTmp;
                            } else {
                                itemList.push({
                                    id: itemId,
                                    isActive: true,
                                    hitNumber: 0,
                                    order: itemList.length,
                                    listTicketId: [ticket.id]
                                });
                                itemIdList.push(itemId);
                            }
                        });
                    }
                });
            }
        }
        const typeOfItem = Utils.getPrefixOfId(itemIdList[0]);

        const itemDetailList = await getListItemFromListId(argsCommon.API, itemIdList, typeOfItem);

        if (typeOfItem !== 'tag') {
            itemDetailList.forEach(itemDetail => {
                const indexOfItem = itemList.findIndex(item => item.id === itemDetail.id);

                if (indexOfItem || indexOfItem === 0) {
                    let itemTmp = itemList[indexOfItem];
                    itemTmp.labelItem = Utils.convertJSONDataToObject(itemDetail.outline).jp;
                    itemList[indexOfItem] = itemTmp;
                }
            });
        }
        if (typeOfItem === 'tag') {
            itemDetailList.forEach(itemDetail => {
                const indexOfItem = itemList.findIndex(item => item.id === itemDetail.id);

                if (indexOfItem || indexOfItem === 0) {
                    let itemTmp = itemList[indexOfItem];
                    itemTmp.labelItem = Utils.getTextByLanguage(
                        Constant.LANGUAGE_TYPE.JP,
                        itemDetail.name
                    );
                    itemList[indexOfItem] = itemTmp;
                }
            });
        }

        argsCommon.setIsLoading(false);
        argsCommon.setItemOfSelectedRelatedFieldList([...itemList]);
    } catch (err) {
        argsCommon.setIsLoading(false);
        return [];
    }
};

const getListItemFromListId = async (API, listId, type) => {
    let promiseAll = [];

    if (type !== 'tag') {
        listId.forEach(id => {
            promiseAll.push(getTicketById(API, id));
        });
    }
    if (type === 'tag') {
        listId.forEach(id => {
            promiseAll.push(getFormById(API, id));
        });
    }

    const listItemDetail = await Promise.all(promiseAll);
    return listItemDetail;
};

export const getFormMasterList = argsCommon => {
    argsCommon.setIsLoading(true);
    getFormMasterListByProject(
        argsCommon.API,
        argsCommon.projectDetail.affiliationOrganization,
        argsCommon.projectDetail.id
    )
        .then(resGetListMasterForm => {
            
            let listFormMaster = Utils.sortByCreatedAtDesc(resGetListMasterForm);
            
            // get list form master shared
            const listFormMasterOutOrg = argsCommon?.listFormOfProject?.filter(form => {
                return (
                    form.type === Constant.FORM_TYPE.FORM_MASTER &&
                    form.affiliationOrganization !==
                        argsCommon.projectDetail.affiliationOrganization &&
                    form?.usingProjects?.includes(argsCommon.projectDetail.id)
                );
            });
            

            listFormMaster = !Utils.isEmptyArray(listFormMasterOutOrg) ? [...listFormMaster,...listFormMasterOutOrg] : listFormMaster
            
            argsCommon.setFormMasterList(listFormMaster);

            try {
                if (argsCommon.autoFillMasterField.formMaster) {
                    const formDetail = resGetListMasterForm.find(
                        form => form.id === argsCommon.autoFillMasterField.formMaster
                    );
                    const structure = Utils.convertJSONDataToObject(formDetail.structure);
                    const listFieldOfForm = getListFieldInForm(
                        structure,
                        argsCommon.fieldListInState
                    );
                    const listTagField = listFieldOfForm.filter(
                        field => field.type === Constant.FORM_TYPE.FIELD_TAG
                    );

                    argsCommon.setRelatedFieldList([...listTagField]);
                }
            } catch (err) {}
        })
        .catch(err => {
            argsCommon.setFormMasterList([]);
        })
        .finally(() => {
            argsCommon.setIsLoading(false);
        });
};
